import parser from 'html-react-parser';
import React from 'react';
import { commaSeperator } from '../../../../../utils/validation';
import { Deals } from '../../../../deals/redux/types';
import { createInterestRate, getType } from '../../../utils';
import { titleClass, valueClass } from '../GridView';

type Props = {
    list: Deals[];
};

const RecentlyClosedMobile: React.FC<Props> = ({ list }) => {
    return (
        <div className="w-full pt-6">
            {list.slice(0, 3).map((d) => (
                <div className="bg-white px-4 py-2 mb-2" key={`${d.deal.uuid}_m_recently_closed_deals`}>
                    <div className="flex items-center">
                        <div
                            className="bg-cover bg-no-repeat h-[66px] w-[66px]"
                            style={d.deal.image ? { backgroundImage: `url(${d.deal.image})` } : {}}
                        >
                            <div>
                                {getType(d.deal.info.summary?.dealType) !== '' && (
                                    <label className="bg-[#142C53] w-auto px-2 py-1 text-[white] font-[WorkSans] font-bold text-xs">
                                        {getType(d.deal.info.summary?.dealType)}
                                    </label>
                                )}
                            </div>
                        </div>
                        <div className="pl-3">
                            <p className="text-[#181818] font-[WorkSans-Semibold] text-sm font-bold">
                                {d.deal.info.summary?.title}
                            </p>
                            <p className="text-[#747474] font-[WorkSans] text-xs line_truc min-h-[3rem]">
                                {d.deal.info.summary?.description}
                            </p>
                        </div>
                    </div>
                    <div className="grid grid-cols-2 gap-4 pt-4">
                        <div>
                            <p className={titleClass}>Industry</p>
                            <p className={valueClass}>{d.issuer?.category}</p>
                        </div>
                        <div>
                            <p className={titleClass}>Instrument Type</p>
                            <p className={valueClass}>{d.deal.info.summary?.instrumentType}</p>
                        </div>
                        <div>
                            <p className={titleClass}>Target Funding Size</p>
                            <p className={valueClass}>
                                {' '}
                                {d.deal.info.summary?.targetFundingSize
                                    ? `${d.deal.info.summary.targetFundingSize.currency} ${commaSeperator(
                                          String(d.deal.info.summary.targetFundingSize.amountUpto2dp || 0),
                                      )}`
                                    : 'NA'}
                            </p>
                        </div>
                        <div>
                            <p className={titleClass}>Target Returns</p>
                            <p className={valueClass}>{parser(createInterestRate(d.deal))}</p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default RecentlyClosedMobile;
